import { Button, Label, TextArea, TextField } from "@heroui/react";
import { type AdminCharacter, type AdminLocation, BRIEF_MIN_LENGTH } from "@storyline/shared";
import { useState } from "react";
import PropositionEditor from "@/src/series/components/proposition-editor";
import { useNewEpisode } from "@/src/series/hooks/use-new-episode";

type NewEpisodePanelProps = {
	seriesId: string;
	characters: AdminCharacter[];
	locations: AdminLocation[];
	onCreated: (episodeId: string) => void;
	onCancel: () => void;
};

const NewEpisodePanel: React.FC<NewEpisodePanelProps> = ({ seriesId, characters, locations, onCreated, onCancel }) => {
	const { plan, isProposing, isCommitting, error, propose, commit, reset } = useNewEpisode(seriesId, onCreated);
	const [brief, setBrief] = useState("");

	if (plan) {
		return (
			<PropositionEditor
				plan={plan}
				characters={characters}
				locations={locations}
				isCommitting={isCommitting}
				error={error}
				onCommit={(edited) => void commit(edited)}
				onCancel={reset}
			/>
		);
	}

	return (
		<div className="flex flex-col gap-4 rounded-xl border border-border-soft bg-surface p-5">
			{error ? <p className="rounded-lg border border-danger/40 bg-glass p-3 text-danger text-sm">{error}</p> : null}
			<TextField value={brief} onChange={setBrief}>
				<Label>Brief de l'épisode</Label>
				<TextArea placeholder="Ce que vit le spectateur, les enjeux, les bifurcations souhaitées…" rows={4} />
			</TextField>
			<div className="flex items-center justify-end gap-2">
				<Button variant="ghost" className="text-muted" onPress={onCancel}>
					Annuler
				</Button>
				<Button isDisabled={isProposing || brief.trim().length < BRIEF_MIN_LENGTH} onPress={() => void propose(brief)}>
					{isProposing ? "Le copilote écrit…" : "Proposer un épisode"}
				</Button>
			</div>
		</div>
	);
};

export default NewEpisodePanel;
